<script>
/**
 * @Author: zhangxiaojian
 * @Date: 2025/6/26
 * @LastEditors: zhangxiaojian
 * @Description 引用的参考资料
 **/
import * as apis from '@apis'
import { getOpenUrl } from '@common/handleModules'

export default {
  name: 'Articles',
  props: {
    articles: {
      // 引用的文章列表
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isExpanded: true // 默认展开状态
    }
  },
  methods: {
    /**
     * 处理引用片段内容
     * @param content
     * @returns {*}
     */
    processContent(content) {
      // 处理逻辑
      return content
        .map((item) => {
          return `<p style="margin-bottom:10px;">${item}</p>`
        })
        .join('')
    },
    /**
     * 切换展开/收起状态
     */
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    },

    /**
     * 前往稿件详细信息页面
     * @param item
     */
    async goDetail(item) {
      let doclbId = item.id.split(',')[0]
      switch (doclbId) {
        case '6':
          // 稿源库文章详情
          await this.originalArticle(item)
          break
        case '442':
          // 见报稿件文章详情
          await this.rcPaper(item)
          break
        default:
          break
      }
    },
    /**
     * 构建稿源库文章详情页面的url，并跳转
     * @param item
     * @returns {Promise<void>}
     */
    async originalArticle(item) {
      // 获取文章详情，用于拼接url参数
      let articleInfo = await apis.MediaCloudArticleOriginEdit.getArticlesDetails(
        {
          params: {
            id: item.id
          }
        }
      )
      if (articleInfo.data.status === 0) {
        let article = articleInfo.data.data.data
        let params = {
          columnId: article.columnId,
          column: article.column,
          type: article.type,
          id: item.id,
          ids: [item.id],
          status: article.status,
          channel: article.channel,
          metadata: JSON.stringify({
            mod: 'article-root'
          })
        }
        let url = getOpenUrl({
          url: 'open/mediacloud-article-origin/root-article-detail',
          params
        })
        window.open(url, '_blank')
      } else {
        this.$message.error(articleInfo.data.message)
      }
    },
    /**
     * 构建见报稿件文章详情页面的url，并跳转
     * @param item
     * @returns {Promise<void>}
     */
    async rcPaper(item) {
      let base = {
        mod: 'mate-paper-photo',
        docLib: 442,
        docTypeID: 442,
        roleID: 0,
        articleId: item.id,
        ids: [item.id],
        docID: item.id.split(',')[1],
        paperCatId: item.paperId,
        paper: item.paperId
      }
      let url = getOpenUrl({
        url: 'open/rc-paper/paper-detail',
        params: { base }
      })
      window.open(url, '_blank')
    }
  }
}
</script>

<template>
  <div class="message-article">
    <div class="message-article-count" @click="toggleExpand">
      <span>引用{{ articles.length }}篇资料作为参考</span>
      <i
        :class="[
          'el-icon-arrow',
          isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
        ]"
      />
    </div>
    <div class="message-article-container" :class="{ collapsed: !isExpanded }">
      <div
        class="message-article-group"
        v-for="(item, index) in articles"
        :key="item.id"
      >
        <el-popover
          popper-class="message-article-custom-popover"
          placement="top"
          :visible-arrow="false"
          width="600"
          trigger="click"
        >
          <div>
            <div class="message-article-custom-popover-title">
              <span>{{ item.title }}</span>
              <span @click="goDetail(item)">查看原文 >></span>
            </div>
            <div
              class="message-article-custom-popover-content"
              v-html="processContent(item.contents)"
            ></div>
          </div>
          <div slot="reference">
            <div>
              {{ index + 1 }}.
              {{ item.title }}
            </div>
            <div class="message-article-group-info">
              <span>{{ item.position }}</span>
              <span>{{ item.date }}</span>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.message-article {
  color: #969798;
  font-size: 12px;
  margin-top: 15px;
  &-count {
    font-size: 14px;
    cursor: pointer;
  }
  &-container {
    overflow: hidden;
    transition: all 0.3s ease;

    &.collapsed {
      max-height: 0 !important;
      opacity: 0;
      margin-bottom: 0;
    }
  }
  &-custom-popover {
    &-title {
      margin-bottom: 15px;
      span {
        font-size: 14px;
        font-weight: bold;
        &:first-child {
          display: block;
          margin-bottom: 5px;
          color: #454647;
        }
        &:last-child {
          color: #006bff;
          cursor: pointer;
        }
      }
    }
    &-content {
      font-size: 13px;
      line-height: 2;
      text-indent: 2em;
      max-height: 300px;
      overflow: auto;
    }
  }
  &-group {
    margin-bottom: 5px;
    cursor: pointer;
    &-info {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
<style lang="scss">
.message-article-custom-popover {
  .popper__arrow {
    display: none !important;
  }
}
</style>
